/**
 * Format: Search
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API search responses.
 *
 */
import { transformEdges } from '~/helpers/graphql';
import { formatProduct } from '~/format/format-product';

/**
 * Format search.
 * - https://shopify.dev/docs/api/storefront/2023-10/objects/Search
 * @param {Object} response - Search response.
 * @returns {Object}
 */
export function formatSearch(response) {
  const search = response.search;

  const formattedSearch = {
    pageInfo: {
      ...search?.pageInfo,
      currentPage: 1,
    },
    articles: [],
    pages: [],
  };

  /**
   * Separate and format different result types.
   */
  const allResults = transformEdges(search);

  formattedSearch.products = allResults
    .filter((result) => result?.id.includes('Product'))
    .map(formatProduct);

  formattedSearch.articles = allResults.filter((result) =>
    result?.id.includes('Article'),
  );

  formattedSearch.pages = allResults.filter((result) =>
    result?.id.includes('Page'),
  );

  return formattedSearch;
}
